(async () => {
    if (!customElements.get("good-practices")) {
        class GoodPractices extends HTMLElement {
            constructor() {
                super();
                this.swiperElement = this.querySelector("[data-good-practices-swiper]");
                this.swiperOptions = {
                    autoplay: false,
                    slidesPerView: 3.5,
                    observer: false,
                    threshold: 10,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.5,
                            spaceBetween: 15,
                            autoplay: false,
                        },
                        768: {
                            slidesPerView: 2.5,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 3.5,
                            spaceBetween: 20,
                        },
                        1440: {
                            slidesPerView: 3.5,
                            spaceBetween: 20,
                        },
                    },
                    on: {
                        init: () => {
                            // Pause autoplay on hover
                            this.swiperElement.addEventListener("mouseenter", () => {
                                this.swiperInstance.autoplay.stop();
                            });
                            // Resume autoplay on mouse leave
                            this.swiperElement.addEventListener("mouseleave", () => {
                                this.swiperInstance.autoplay.start();
                            });
                        },
                    },
                };

                // Check if we have extra options on the HTML
                if (this && this.dataset && this.dataset.options) {
                    const jsonOptions = JSON.parse(this.dataset.options);
                    if (jsonOptions) {
                        this.swiperOptions = {
                            ...this.swiperOptions,
                            ...jsonOptions,
                        };
                    }
                }

                // re-init slider when Theme Editor is active
                if (Shopify.designMode && this.swiperInstance) {
                    window.addEventListener("shopify:section:load", () => {
                        this.swiperInstance.update();
                    });
                }
                this.init();
            }

            init() {
                this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
            }
        }

        window.GoodPractices = GoodPractices;

        customElements.define("good-practices", GoodPractices);
    }
   
})();